import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';

export const showTouchpointNotFoundModal = (
  defaultTouchpointNotFound: boolean = false,
): Promise<void> => {
  return new Promise<void>(resolve => {
    const messageModal: IMessageModal = {
      ...(defaultTouchpointNotFound ? messagePropsDefaultNotFound : messageProps),
      onAccept: () => resolve(),
    };
    popupMessage(messageModal);
  });
};

const messageProps: IMessageModal = {
  type: EmeraldDialogTypes.Warning,
  message: 'TouchpointNotFound',
  subMessage: 'TouchpointNotFoundSubMessage',
  hideCancelButton: true,
  acceptButtonLabel: 'OK_Button',
};

const messagePropsDefaultNotFound: IMessageModal = {
  type: EmeraldDialogTypes.Warning,
  message: 'TouchpointNotFound',
  subMessage: 'DefaultTouchpointNotFoundSubMessage',
  hideCancelButton: true,
  acceptButtonLabel: 'OK_Button',
};
